import React from 'react';
import PropTypes from 'prop-types';

import { useDrag } from 'react-dnd'

import Block from '../Block'

const propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.func,
};

export default function DndBlock({ type, model, title, icon }) {
  const [{ isDragging }, dragReference] = useDrag(() => ({
    type: type,
    item: { type, model, path() { return 'pallet' } },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  }))

  return <Block
    title={title}
    icon={icon}
    dragReference={dragReference}
    extraStyles={isDragging ? { color: 'skyblue' } : {}}
  />
}

DndBlock.propTypes = propTypes
DndBlock.defaultProps = {}